import api from '@/utils/api';
import { AssistantUpload, AssistantUploadedFile } from '@/lib/types';

// An upload link's target, limits and the files added so far. 404 when the
// link has expired, 403 when it belongs to another account.
export async function getAssistantUpload(uploadId: string): Promise<AssistantUpload> {
  const res = await api.get(`assistant-uploads/${encodeURIComponent(uploadId)}`);
  return res.data.resource as AssistantUpload;
}

// Uploads one file through the link; the API attaches it before answering.
// onProgress reports the share of the file sent, 0-100.
export async function uploadAssistantFile(
  uploadId: string,
  file: File,
  onProgress: (percent: number) => void,
  signal?: AbortSignal,
): Promise<AssistantUploadedFile> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post(`assistant-uploads/${encodeURIComponent(uploadId)}`, form, {
    signal,
    onUploadProgress: (e) => {
      if (e.total) onProgress((e.loaded / e.total) * 100);
    },
  });
  return res.data.resource as AssistantUploadedFile;
}
